import { Nullable } from '@/shared/types/app.types'
import { OperationResponse } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/operation/operation.dto'
import { AssayModalAssayWithValuableConceptResponse } from '@/components/assays-view/services/assays-view-assay/assays-view-assay.dto'
import { ConfigurationSectionResponse } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/configuration-section/configuration-section.dto'
import { ConfigurationDefaultDeviceConfigurationResponse } from '@/modules/configurationModule/detail/instrumentation/devices/services/configuration-default-device-configuration/configuration-default-device-configuration.dto'
import { store } from '@/store/store'

export interface ConfigurationInstrumentationDevicesModalNotificationsFormState {
    defaultDeviceConfigurations: ConfigurationDefaultDeviceConfigurationResponse[]
    operations: OperationResponse[]
    assays: AssayModalAssayWithValuableConceptResponse[]
    sections: ConfigurationSectionResponse[]
    operation: Nullable<OperationResponse>
    assay: Nullable<AssayModalAssayWithValuableConceptResponse>
    section: Nullable<ConfigurationSectionResponse>
    laboratoryId: number
}
export const initialConfigurationInstrumentationDevicesModalNotificationsFormState =
    (): ConfigurationInstrumentationDevicesModalNotificationsFormState => ({
        defaultDeviceConfigurations: [],
        operations: [],
        assays: [],
        sections: [],
        operation: null,
        assay: null,
        section: null,
        laboratoryId: store.getters.labId
    })
